import { render, staticRenderFns } from "./version-group-select.vue?vue&type=template&id=6433db36"
import script from "./version-group-select.ts?vue&type=script&lang=ts&external"
export * from "./version-group-select.ts?vue&type=script&lang=ts&external"
import style0 from "./version-group-select.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports